import { render, staticRenderFns } from "./InstitutionEdit.vue?vue&type=template&id=818fbca4&scoped=true"
import script from "./InstitutionEdit.vue?vue&type=script&lang=js"
export * from "./InstitutionEdit.vue?vue&type=script&lang=js"
import style0 from "./InstitutionEdit.vue?vue&type=style&index=0&id=818fbca4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818fbca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('818fbca4')) {
      api.createRecord('818fbca4', component.options)
    } else {
      api.reload('818fbca4', component.options)
    }
    module.hot.accept("./InstitutionEdit.vue?vue&type=template&id=818fbca4&scoped=true", function () {
      api.rerender('818fbca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/institutions/InstitutionEdit.vue"
export default component.exports